"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MaterialListDialogsProvider = void 0;
const provider_base_1 = require("../provider-base");
const fragments_1 = require("../../fragments");
class MaterialListDialogsProvider extends provider_base_1.BaseProvider {
    static async getMaterialListFragment() {
        const fragment = await fragments_1.FragmentsLoaderProvider.fragmentsLoader.loadFragment(fragments_1.FragmentName.materialList);
        return fragment;
    }
    static async openOrganizationTemplatesDialog(parentVueInstance) {
        const materialListFragment = await this.getMaterialListFragment();
        const mountUtils = fragments_1.MountUtils.createInstance(parentVueInstance);
        this.mountedDialogs.organizationTemplatesDialog = await mountUtils.mountDialog(materialListFragment, materialListFragment.organizationTemplatesDialog);
    }
    static async closeOrganizationTemplatesDialog() {
        var _a;
        await ((_a = this.mountedDialogs.organizationTemplatesDialog) === null || _a === void 0 ? void 0 : _a.close());
        delete this.mountedDialogs.organizationTemplatesDialog;
    }
    static async openCourseCreationDialog(parentVueInstance, creationMethod, isCourseCreationLimitReached) {
        const materialListFragment = await this.getMaterialListFragment();
        const mountUtils = fragments_1.MountUtils.createInstance(parentVueInstance);
        this.mountedDialogs.courseCreationDialog = await mountUtils.mountDialog(materialListFragment, materialListFragment.courseCreationDialog, {
            creationMethod,
            isCourseCreationLimitReached
        });
    }
    static async closeCourseCreationDialog() {
        var _a;
        await ((_a = this.mountedDialogs.courseCreationDialog) === null || _a === void 0 ? void 0 : _a.close());
        delete this.mountedDialogs.courseCreationDialog;
    }
}
exports.MaterialListDialogsProvider = MaterialListDialogsProvider;
